<script>
export default {
    name: 'CircleCheckIcon',
    props: {
    iconColor: {
      type: String,
      default: '#808080'
    },
    strokeColor: {
      type: String,
      default: '#808080'
    },
    width: {
      type: [Number, String],
      default: 32
    },
    height: {
      type: [Number, String],
      default: 32
    },
    viewBox: {
      type: String,
      default: '0 0 32 32'
    }
  }
}
</script>

<template>
    <svg :width="width" :height="height" :viewBox="viewBox" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" :stroke="strokeColor" stroke-dasharray="2 2" />
        <g clip-path="url(#clip0_6389_20481)">
            <path
                d="M12.9996 20.1701L9.52965 16.7001C9.13965 16.3101 8.50965 16.3101 8.11965 16.7001C7.72965 17.0901 7.72965 17.7201 8.11965 18.1101L12.2996 22.2901C12.6896 22.6801 13.3196 22.6801 13.7096 22.2901L24.2896 11.7101C24.6796 11.3201 24.6796 10.6901 24.2896 10.3001C23.8997 9.91007 23.2696 9.91007 22.8796 10.3001L12.9996 20.1701Z"
                :fill="iconColor" />
        </g>
    </svg>
</template>